


































import { Component, Prop, Vue } from 'vue-property-decorator';

import MmHintedButton from '../../components/MmHintedButton.vue';
import { MM_TASK_TYPES, MmTaskType } from '../../types/enums';
import { listTaskTypeOptions, MmTaskTypeListOption } from './taskTypeProfile';

const KEY = 'priceMonitoring.mobileMonitoring.taskForm.';

interface MmTaskCreateMenuOption {
	type: MmTaskType;
	label: string;
	isDisabled: boolean;
	disabledReason: string;
}

@Component({
	components: { MmHintedButton },
})
export default class TaskCreateMenu extends Vue {
	/** disabled нужен и на a-dropdown, и на кнопке: dropdown перезаписывает его своему триггеру */
	@Prop({ default: false }) readonly disabled!: boolean;

	@Prop({ default: '' }) readonly disabledReason!: string;

	get buttonText(): string {
		return this.$t(KEY + 'newTask') as string;
	}

	get menuLabel(): string {
		return this.$t(KEY + 'newTaskMenuLabel') as string;
	}

	get typeOptions(): MmTaskCreateMenuOption[] {
		const self = this;

		return listTaskTypeOptions().map(function (option: MmTaskTypeListOption): MmTaskCreateMenuOption {
			return {
				type: option.type,
				label: option.labelKey !== '' ? (self.$t(option.labelKey) as string) : String(option.type),
				isDisabled: option.isDisabled,
				disabledReason: option.disabledReasonKey !== null
					? (self.$t(option.disabledReasonKey) as string)
					: '',
			};
		});
	}

	handleMenuClick(event: { key: string }): void {
		const key = event && event.key ? String(event.key) : '';
		const index = (MM_TASK_TYPES as string[]).indexOf(key);

		if (index === -1) {
			return;
		}

		const type = MM_TASK_TYPES[index];
		const options = this.typeOptions;

		for (let i = 0; i < options.length; i += 1) {
			if (options[i].type === type && options[i].isDisabled) {
				return;
			}
		}

		this.$emit('select', type);
	}
}
